import "../css/Home.css";

const Home = () => {
  return (
    <main className="night-home">

      {/* NEW HERO (TEXT-DRIVEN) */}
      <section className="night-intro">
        <div className="intro-left">
          <h1>
            NEO<br />
            CAFÉ
          </h1>
        </div>

        <div className="intro-right">
          <p className="intro-tag">
            A NIGHT CAFÉ
          </p>
          <p className="intro-text">
            A modern coffee space designed
            for evenings, conversations,
            and slow moments in a fast city.
          </p>
        </div>
      </section>

      {/* REST OF PAGE UNCHANGED */}
      {/* QUIET STATEMENT */}
      <section className="night-quiet">
        <p>
          When the city slows down,<br />
          we begin.
        </p>
      </section>

      {/* SPACE + IMAGE */}
      <section className="night-space">
        <div className="space-text">
          <h2>The Space</h2>
          <p>
            Clean lines. Low light.  
            A room designed to hold silence
            without feeling empty.
          </p>
        </div>
        <div className="space-image img-one" />
      </section>

      <section className="night-space reverse">
        <div className="space-text">
          <h2>The Coffee</h2>
          <p>
            Espresso-forward blends,
            crafted to cut through the night —
            rich, bold, and grounded.
          </p>
        </div>
        <div className="space-image img-two" />
      </section>

      <section className="night-typography">
        <h2>
          Designed for people<br />
          who stay longer.
        </h2>
      </section>

      <section className="night-experience">
        <div>
          <span>Hours</span>
          <h3>Late Nights</h3>
          <p>Open until the city quiets.</p>
        </div>
        <div>
          <span>Sound</span>
          <h3>Low Volume</h3>
          <p>Music that never competes.</p>
        </div>
        <div>
          <span>Menu</span>
          <h3>Focused</h3>
          <p>Only what matters.</p>
        </div>
      </section>

      <section className="night-full">
        <p>
          Coffee feels different<br />
          after midnight.
        </p>
      </section>

      <section className="night-closing">
        <h2>See You Tonight</h2>
        <p>No rush. No noise. Just coffee.</p>
      </section>

    </main>
  );
};

export default Home;
